import { useState, useCallback, useRef } from "react";
import { searchOccupations, getOccupationDetail } from "../api/client";
import type { OccupationSearchItem, OccupationDetail } from "../types";

export function useOccupation() {
  const [results, setResults] = useState<OccupationSearchItem[]>([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const search = useCallback((q: string, category?: string) => {
    if (!q.trim()) { setResults([]); return; }
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      const res = await searchOccupations(q, category);
      if (res.success) setResults(res.data ?? []);
      setLoading(false);
    }, 300);
  }, []);

  const getDetail = useCallback(async (id: number): Promise<OccupationDetail | null> => {
    const res = await getOccupationDetail(id);
    return res.success ? res.data : null;
  }, []);

  return { results, loading, search, getDetail };
}
